{
  "app": {
    "name": "Administration pénitentiaire",
    "sub": "Gestion des concours",
    "title": "Gestion des concours"
  },
  "nav": {
    "pilotage": "Pilotage",
    "dashboard": "Tableau de bord",
    "competitions": "Concours",
    "forms": "Formulaires",
    "dossiers": "Dossiers",
    "applications": "Candidatures",
    "payments": "Paiements",
    "selection": "Sélection",
    "stages": "Étapes et barèmes",
    "grades": "Mes relevés de notes",
    "commissions": "Commissions et notes",
    "results": "Résultats",
    "approvals": "Approbations et publications",
    "documents": "Convocations et documents",
    "communication": "Communication",
    "exports": "Exports",
    "campaigns": "Envois groupés",
    "notificationHistory": "Historique des notifications",
    "notificationTemplates": "Modèles de notification",
    "notificationProviders": "Fournisseurs email / SMS",
    "administration": "Administration",
    "users": "Utilisateurs",
    "roles": "Profils et permissions",
    "paymentMethods": "Moyens de paiement",
    "audit": "Journal d’audit",
    "design": "Design system",
    "mfaRequired": "MFA requise",
    "duplicates": "Doublons",
    "corrections": "Corrections"
  },
  "dashboard": {
    "eyebrow": "Vue d’ensemble",
    "title": "Tableau de bord",
    "description": "Suivi des concours, des dossiers et des opérations en cours.",
    "apiState": "État de la plateforme",
    "up": "disponible",
    "down": "indisponible",
    "unreachable": "API injoignable",
    "checking": "Vérification…",
    "statsSoon": "Les indicateurs seront alimentés à partir de la phase 19."
  },
  "comingSoon": {
    "eyebrow": "En construction",
    "title": "{{page}}",
    "description": "Ce module est prévu en phase {{phase}} de la feuille de route (TODO.md)."
  },
  "errors": {
    "notFound": "Page introuvable",
    "notFoundText": "L’adresse demandée n’existe pas ou a été déplacée.",
    "forbidden": "Accès refusé",
    "forbiddenText": "Votre profil ne dispose pas des permissions nécessaires pour cette page.",
    "home": "Retour au tableau de bord"
  },
  "user": {
    "account": "Mon compte",
    "logout": "Se déconnecter",
    "menu": "Menu du compte"
  },
  "auth": {
    "login": {
      "title": "Connexion",
      "description": "Espace réservé aux agents habilités.",
      "email": "Adresse électronique",
      "password": "Mot de passe",
      "submit": "Se connecter",
      "forgot": "Mot de passe oublié ?",
      "noSignup": "Les comptes sont créés par un administrateur (invitation par email)."
    },
    "mfa": {
      "title": "Double authentification",
      "description": "Saisissez le code à 6 chiffres affiché par votre application d’authentification.",
      "submit": "Valider",
      "useRecovery": "Utiliser un code de secours",
      "useTotp": "Utiliser l’application",
      "recovery": "Code de secours",
      "recoveryHint": "Format XXXXX-XXXXX. Chaque code ne sert qu’une fois.",
      "back": "Recommencer la connexion"
    },
    "forgot": {
      "title": "Mot de passe oublié",
      "description": "Indiquez l’adresse de votre compte : vous recevrez un lien pour choisir un nouveau mot de passe.",
      "submit": "Envoyer le lien",
      "sent": "Si un compte correspond à cette adresse, un lien valable 30 minutes vient d’être envoyé.",
      "back": "Retour à la connexion"
    },
    "reset": {
      "title": "Nouveau mot de passe",
      "description": "Choisissez un nouveau mot de passe. Toutes vos sessions ouvertes seront fermées.",
      "submit": "Enregistrer",
      "done": "Mot de passe modifié. Vous pouvez vous connecter.",
      "missingToken": "Lien incomplet. Utilisez le lien reçu par email ou faites une nouvelle demande.",
      "newRequest": "Faire une nouvelle demande"
    },
    "invitation": {
      "title": "Activer votre compte",
      "description": "Bienvenue {{name}}. Choisissez votre mot de passe pour activer le compte {{email}}.",
      "submit": "Activer mon compte",
      "invalid": "Cette invitation est invalide ou a expiré. Demandez une nouvelle invitation à votre administrateur."
    },
    "password": "Mot de passe",
    "passwordConfirmation": "Confirmer le mot de passe",
    "mismatch": "Les deux mots de passe ne correspondent pas."
  },
  "account": {
    "eyebrow": "Mon compte",
    "title": "Sécurité du compte",
    "description": "Informations personnelles, mot de passe et double authentification.",
    "identity": "Identité",
    "name": "Nom",
    "email": "Adresse électronique",
    "lastLogin": "Dernière connexion",
    "password": {
      "title": "Changer le mot de passe",
      "current": "Mot de passe actuel",
      "new": "Nouveau mot de passe",
      "confirm": "Confirmer le nouveau mot de passe",
      "submit": "Modifier le mot de passe",
      "done": "Mot de passe modifié. Vos autres sessions ont été fermées."
    },
    "mfa": {
      "title": "Double authentification (TOTP)",
      "enabled": "Activée",
      "disabled": "Désactivée",
      "explain": "Un code temporaire, généré par une application (Google Authenticator, Microsoft Authenticator, FreeOTP…), vous sera demandé à chaque connexion.",
      "remaining": "Codes de secours restants : {{count}}",
      "enable": "Activer la double authentification",
      "step1": "1. Scannez ce QR code avec votre application d’authentification.",
      "manual": "Ou saisissez cette clé manuellement :",
      "step2": "2. Saisissez le code à 6 chiffres affiché pour confirmer.",
      "confirm": "Confirmer l’activation",
      "cancel": "Annuler",
      "codesTitle": "Vos codes de secours",
      "codesHelp": "Conservez-les en lieu sûr (gestionnaire de mots de passe, impression). Chacun permet UNE connexion si vous n’avez plus accès à votre application. Ils ne seront plus affichés.",
      "copy": "Copier",
      "copied": "Copié",
      "download": "Télécharger",
      "done": "J’ai conservé mes codes",
      "disable": "Désactiver",
      "disableTitle": "Désactiver la double authentification",
      "disableHelp": "Saisissez votre mot de passe et un code de l’application (ou un code de secours).",
      "code": "Code",
      "required": "Votre profil exige la double authentification."
    },
    "sessions": {
      "title": "Sessions",
      "help": "Fermez toutes les sessions ouvertes sur vos autres appareils et navigateurs.",
      "logoutAll": "Me déconnecter partout"
    }
  },
  "rbac": {
    "roles": {
      "eyebrow": "Administration",
      "title": "Profils et permissions",
      "description": "Chaque profil regroupe des permissions. Un utilisateur peut cumuler plusieurs profils, éventuellement limités à un concours ou une étape.",
      "new": "Nouveau profil",
      "code": "Code",
      "label": "Libellé",
      "permissions": "Permissions",
      "users": "Utilisateurs",
      "system": "Système",
      "mfa": "MFA exigée",
      "inactive": "Désactivé",
      "empty": "Aucun profil"
    },
    "create": {
      "title": "Nouveau profil",
      "description": "Le code est un identifiant technique stable (minuscules, chiffres, _). Les permissions se choisissent ensuite dans la matrice.",
      "code": "Code",
      "codeHint": "Ex. controleur_dossiers — non modifiable ensuite.",
      "label": "Libellé",
      "descriptionField": "Description",
      "from": "Copier les permissions de",
      "fromNone": "Aucun (profil vide)",
      "submit": "Créer le profil",
      "cancel": "Annuler"
    },
    "editor": {
      "back": "Tous les profils",
      "tabPermissions": "Permissions",
      "tabInfo": "Informations",
      "tabHolders": "Titulaires",
      "superAdminNote": "Le super administrateur détient toujours toutes les permissions, y compris celles ajoutées à l’avenir. Sa matrice n’est pas modifiable.",
      "readOnly": "Lecture seule : vous n’avez pas la permission de modifier les profils.",
      "notHeld": "Vous ne détenez pas cette permission : vous ne pouvez ni l’accorder ni la retirer.",
      "all": "Tout cocher",
      "none": "Tout décocher",
      "changes": "{{added}} ajout(s), {{removed}} retrait(s)",
      "noChange": "Aucune modification",
      "save": "Enregistrer les permissions",
      "reset": "Annuler les modifications",
      "sensitive": "Sensible",
      "sodBlock": "Cumul interdit",
      "sodWarn": "Cumul à surveiller",
      "confirmTitle": "Enregistrer les permissions du profil ?",
      "confirmText": "Les titulaires de ce profil verront leurs droits mis à jour immédiatement.",
      "added": "Ajoutées",
      "removed": "Retirées",
      "saved": "Permissions enregistrées",
      "infoSave": "Enregistrer",
      "requiresMfa": "Exiger la double authentification",
      "requiresMfaHint": "Les titulaires devront activer la MFA avant d’accéder au portail.",
      "defaultScope": "Périmètre proposé à l’attribution",
      "active": "Profil actif",
      "activeHint": "Un profil désactivé ne donne plus aucun droit (les affectations sont conservées).",
      "duplicate": "Dupliquer",
      "delete": "Supprimer",
      "deleteTitle": "Supprimer ce profil ?",
      "deleteText": "Possible uniquement s’il n’a jamais été attribué. Sinon, désactivez-le.",
      "holdersEmpty": "Aucun titulaire actif",
      "scope": "Périmètre",
      "until": "Jusqu’au"
    },
    "users": {
      "title": "Utilisateurs",
      "description": "Comptes internes (agents, commissions, autorités). Les comptes sont créés par invitation.",
      "invite": "Inviter un utilisateur",
      "search": "Recherche",
      "searchPlaceholder": "Nom ou adresse",
      "status": "Statut",
      "all": "Tous",
      "role": "Profil",
      "allRoles": "Tous les profils",
      "name": "Nom",
      "email": "Adresse",
      "roles": "Profils",
      "mfa": "MFA",
      "lastLogin": "Dernière connexion",
      "noRole": "Aucun profil",
      "empty": "Aucun utilisateur ne correspond",
      "inviteTitle": "Inviter un utilisateur",
      "inviteText": "Un email avec un lien d’activation (valable 72 h) sera envoyé. L’utilisateur choisira son mot de passe.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "phone": "Téléphone",
      "send": "Envoyer l’invitation",
      "sent": "Invitation envoyée"
    },
    "user": {
      "back": "Tous les utilisateurs",
      "identity": "Compte",
      "assignments": "Profils attribués",
      "history": "Afficher l’historique",
      "hideHistory": "Masquer l’historique",
      "assign": "Attribuer un profil",
      "revoke": "Retirer",
      "revoked": "Retiré",
      "grantedBy": "Attribué par",
      "reason": "Motif",
      "effective": "Permissions effectives",
      "effectiveHelp": "Résultat de tous les profils actifs, tel que l’API l’applique.",
      "noPermission": "Aucune permission",
      "disable": "Désactiver le compte",
      "enable": "Réactiver le compte",
      "resetMfa": "Réinitialiser la MFA",
      "resend": "Renvoyer l’invitation",
      "self": "C’est votre compte : vos profils sont gérés par un autre administrateur.",
      "assignTitle": "Attribuer un profil",
      "roleField": "Profil",
      "scopeField": "Périmètre",
      "validFrom": "Valable à partir du",
      "validUntil": "Valable jusqu’au",
      "optional": "Facultatif",
      "assignSubmit": "Attribuer",
      "assigned": "Profil attribué",
      "warning": "Attention",
      "revokeTitle": "Retirer ce profil ?",
      "revokeText": "Les droits correspondants sont retirés immédiatement.",
      "disableTitle": "Désactiver ce compte ?",
      "disableText": "Toutes ses sessions sont fermées immédiatement. Le compte et son historique sont conservés.",
      "enableTitle": "Réactiver ce compte ?",
      "resetMfaTitle": "Réinitialiser la double authentification ?",
      "resetMfaText": "À utiliser si l’utilisateur a perdu son téléphone. Ses sessions sont fermées ; il configurera une nouvelle application à sa prochaine connexion.",
      "done": "Modification enregistrée",
      "pendingInvitation": "Invitation envoyée, valable jusqu’au {{date}}.",
      "scopeHint": "Global : toute la plateforme. « Un concours » ou « une étape » : les permissions du profil ne s’appliquent qu’à ce périmètre (ex. un évaluateur sur l’épreuve écrite d’un concours).",
      "scopeCompetition": "Concours",
      "scopeStage": "Étape de sélection",
      "sodTitle": "Cumul interdit par la séparation des responsabilités",
      "sodForce": "Forcer ce cumul en tant que super-administrateur (le motif ci-dessous est obligatoire ; le forçage est inscrit au journal d’audit). Les contrôles « quatre yeux » restent appliqués à chaque action.",
      "sodNoForce": "Seul un super-administrateur peut forcer ce cumul."
    },
    "mfaGate": {
      "title": "Double authentification requise",
      "text": "Un de vos profils exige la double authentification. Activez-la ci-dessous pour accéder au reste du portail."
    }
  },
  "audit": {
    "eyebrow": "Contrôle",
    "title": "Journal d’audit",
    "description": "Toutes les opérations sensibles, en ajout seul : aucune entrée ne peut être modifiée ni supprimée, et chaque ligne est chaînée à la précédente.",
    "export": "Exporter (CSV)",
    "exported": "Export téléchargé",
    "verify": "Vérifier l’intégrité",
    "integrityOk": "Chaîne intègre : {{total}} entrées vérifiées.",
    "integrityKo": "Altération détectée sur {{count}} entrée(s) : {{ids}}. Alertez le responsable sécurité.",
    "from": "Du",
    "to": "Au",
    "category": "Catégorie",
    "allCategories": "Toutes",
    "action": "Action",
    "allActions": "Toutes",
    "result": "Résultat",
    "allResults": "Tous",
    "actor": "Acteur",
    "actorPlaceholder": "Adresse (partielle) ou identifiant",
    "apply": "Filtrer",
    "reset": "Effacer les filtres",
    "resourceFilter": "Filtré sur {{type}} {{id}}",
    "date": "Date",
    "resource": "Ressource",
    "reason": "Motif",
    "empty": "Aucune entrée ne correspond à ces filtres.",
    "anonymous": "Anonyme",
    "system": "Système",
    "sensitive": "Événement de sécurité",
    "detailTitle": "Entrée n° {{id}}",
    "ip": "Adresse IP",
    "requestId": "Identifiant de requête",
    "userAgent": "Navigateur",
    "changes": "Modifications",
    "field": "Champ",
    "before": "Avant",
    "after": "Après",
    "noChanges": "Aucune donnée avant/après pour cette entrée.",
    "metadata": "Détails techniques",
    "integrity": "Empreintes (chaînage)",
    "hash": "Empreinte",
    "prevHash": "Empreinte précédente",
    "added": "Ajouté",
    "removed": "Retiré",
    "close": "Fermer",
    "journal": "Voir dans le journal"
  },
  "competitions": {
    "eyebrow": "Pilotage",
    "title": "Concours",
    "description": "Création, publication et cycle de vie des concours. L’ouverture et la clôture des dépôts sont décidées par le serveur selon les dates.",
    "new": "Nouveau concours",
    "all": "Tous",
    "status": "Statut",
    "period": "Période de dépôt",
    "search": "Recherche",
    "searchPlaceholder": "Intitulé, référence, corps",
    "empty": "Aucun concours",
    "back": "Tous les concours",
    "reasonHint": "10 caractères minimum. Le motif est conservé dans l’historique et le journal d’audit.",
    "fields": {
      "title": "Intitulé officiel",
      "reference": "Référence",
      "referenceHint": "Identifiant métier unique, ex. PEN-2026-AGENTS.",
      "type": "Type de concours",
      "session": "Session",
      "year": "Année",
      "corps": "Corps / emploi",
      "grade": "Grade / catégorie",
      "seats": "Nombre de places",
      "prefix": "Préfixe des matricules",
      "prefixHint": "2 à 6 lettres. Matricule : {{example}}",
      "summary": "Présentation",
      "conditions": "Conditions d’accès",
      "conditionsHint": "Diplômes, âge, nationalité et autres critères applicables.",
      "requiredDocuments": "Pièces requises",
      "documentN": "Pièce {{n}}",
      "removeDocument": "Retirer la pièce {{n}}",
      "addDocument": "Ajouter une pièce",
      "selectionRules": "Règles de sélection et de publication",
      "publicationAt": "Publication de l’avis",
      "publicationHint": "Vide : visible dès la publication.",
      "opensAt": "Ouverture des dépôts",
      "closesAt": "Clôture des dépôts",
      "closesHint": "Ensuite modifiable uniquement par prolongation motivée.",
      "paymentTiming": "Moment du paiement",
      "feeAmount": "Frais d’inscription",
      "paymentDeadlineAt": "Date limite de paiement",
      "paymentDeadlineHint": "Distincte de la clôture des dépôts.",
      "locked": "Figé depuis la publication",
      "ageTitle": "Conditions d’âge (contrôlées à la soumission)",
      "ageHint": "Facultatif. L’âge est apprécié au 31 décembre de l’année du concours, sauf autre date indiquée.",
      "minAge": "Âge minimum",
      "maxAge": "Âge maximum",
      "ageReferenceDate": "Âge apprécié au"
    },
    "wizard": {
      "title": "Nouveau concours",
      "description": "Le concours est créé en brouillon : rien n’est visible du public avant sa publication.",
      "steps": "Étapes de l’assistant",
      "step": {
        "info": "Informations",
        "conditions": "Conditions",
        "calendar": "Calendrier",
        "fees": "Frais",
        "form": "Formulaire",
        "stages": "Étapes de sélection",
        "summary": "Récapitulatif"
      },
      "summaryHint": "Vérifiez les informations : la référence, le préfixe, l’année, le type et les frais seront figés à la publication.",
      "previous": "Précédent",
      "next": "Suivant",
      "create": "Créer le brouillon",
      "created": "Concours créé en brouillon",
      "required": "Champ obligatoire.",
      "formHint": "Choisissez le formulaire de candidature (version publiée) : il sera associé au concours dès sa création. Sans formulaire, les dépôts ne pourront pas ouvrir ; vous pourrez aussi l’associer plus tard depuis l’onglet « Formulaire » de la fiche.",
      "formField": "Formulaire de candidature",
      "formNone": "Aucun pour l’instant",
      "formFieldHint": "La dernière version publiée est utilisée.",
      "formEmpty": "Aucun formulaire publié : créez-en un dans « Formulaires », puis associez-le depuis la fiche du concours.",
      "formNoPermission": "Vous n’avez pas accès aux formulaires : un responsable pourra en associer un depuis la fiche du concours.",
      "formManage": "Gérer les formulaires",
      "formLinkFailed": "Concours créé, mais le formulaire n’a pas pu être associé : faites-le depuis l’onglet « Formulaire ».",
      "stagesHint": "Les étapes de sélection (épreuves physiques, écrits, oraux…), leurs disciplines, barèmes et règles de passage se configurent dans « Étapes et barèmes », une fois le concours créé. Les règles de passage sont ensuite validées par une autre personne.",
      "stagesAfter": "Ouvrir « Étapes et barèmes » juste après la création"
    },
    "tabs": {
      "overview": "Aperçu",
      "edit": "Modifier",
      "calendar": "Calendrier et catégories",
      "notice": "Avis officiel",
      "history": "Historique",
      "derogations": "Dérogations",
      "form": "Formulaire"
    },
    "lifecycle": {
      "title": "Cycle de vie",
      "done": "Statut : {{status}}",
      "notReady": "Le concours n’est pas prêt à être publié",
      "confirm": "Confirmer : {{action}} ?",
      "extend": "Prolonger les dépôts",
      "reopen": "Rouvrir les dépôts",
      "extendText": "Clôture actuelle : {{date}}. La prolongation est tracée avec son motif.",
      "extendSubmit": "Enregistrer la nouvelle date",
      "extended": "Date de clôture modifiée",
      "explainDefault": "L’action est tracée dans l’historique du concours et le journal d’audit.",
      "explain": {
        "published": "L’avis devient visible du public à la date de publication. Référence, préfixe, année, type et frais seront figés.",
        "draft": "Le concours disparaît du portail public.",
        "open": "Les candidats peuvent déposer leur dossier jusqu’à la clôture.",
        "suspended": "Plus aucun dépôt, modification ni soumission tant que le concours est suspendu.",
        "closed": "Plus aucune nouvelle soumission, sauf dérogation individuelle motivée.",
        "processing": "Ouvre la phase de vérification des dossiers et d’organisation des épreuves.",
        "archived": "Le concours passe en consultation historique et n’est plus modifiable."
      }
    },
    "check": {
      "title": "Prêt à publier ?",
      "period": "Dates d’ouverture et de clôture des dépôts",
      "future": "Clôture des dépôts dans le futur",
      "deadline": "Date limite de paiement (si frais)",
      "conditions": "Conditions d’accès renseignées",
      "notice": "Avis officiel (PDF) déposé",
      "fix": "Compléter",
      "ok": "Fait",
      "todo": "À faire",
      "form": "Formulaire de candidature associé (requis pour ouvrir)"
    },
    "edit": {
      "lockedInfo": "Concours publié : certains champs sont figés, et chaque modification exige un motif.",
      "readOnly": "Lecture seule : vous n’avez pas la permission de modifier ce concours.",
      "changes": "{{count}} champ(s) modifié(s)",
      "save": "Enregistrer les modifications"
    },
    "calendar": {
      "title": "Calendrier affiché",
      "help": "Épreuves, publication des résultats… Les jalons non publics restent internes.",
      "label": "Libellé",
      "start": "Début",
      "end": "Fin (facultatif)",
      "public": "Public",
      "remove": "Retirer « {{label}} »",
      "add": "Ajouter un jalon",
      "save": "Enregistrer le calendrier"
    },
    "categories": {
      "title": "Catégories / spécialités",
      "help": "Facultatif. Le total des places ne peut dépasser {{seats}}.",
      "code": "Code",
      "label": "Libellé",
      "add": "Ajouter une catégorie",
      "save": "Enregistrer les catégories"
    },
    "notice": {
      "help": "PDF uniquement, 10 Mo maximum. Chaque dépôt crée une nouvelle version ; le public voit la plus récente.",
      "upload": "Déposer l’avis (PDF)",
      "replace": "Déposer une nouvelle version",
      "uploaded": "Avis déposé (version {{version}})",
      "version": "Version",
      "file": "Fichier",
      "size": "Taille",
      "date": "Déposé le",
      "open": "Ouvrir",
      "none": "Aucun avis déposé"
    },
    "history": {
      "empty": "Aucun événement",
      "extension": "Prolongation : {{before}} → {{after}}",
      "derogationGranted": "Dérogation accordée à {{candidate}}",
      "derogationRevoked": "Dérogation retirée à {{candidate}}"
    },
    "derogations": {
      "help": "Après la clôture, une dérogation autorise UN candidat à déposer ou compléter son dossier jusqu’à une date limite (30 jours maximum).",
      "grant": "Accorder une dérogation",
      "grantText": "Le candidat doit disposer d’un compte. La dérogation est motivée, datée et tracée.",
      "grantSubmit": "Accorder",
      "granted": "Dérogation accordée",
      "candidate": "Candidat",
      "email": "Adresse du compte candidat",
      "until": "Valable jusqu’au",
      "untilHint": "30 jours maximum.",
      "active": "Active",
      "expired": "Expirée",
      "none": "Aucune dérogation",
      "revokeTitle": "Retirer cette dérogation ?"
    }
  }
}
